<template>
  <div id="contact" :class="{mobile: mobile}">
    <h2>Contact Us</h2>
    <p>Phone: <a href="tel:+1-847-515-3335">(847) 515-3335</a></p>
    <p>Email: <a href="mailto:karenfleck3@gmail.com" >karenfleck3@gmail.com</a></p>
    <p>Find us on <a href="https://www.facebook.com/karenimpressions">Facebook!</a></p>
  </div>
</template>

<script>
export default {
  name: 'Contact',

  data () {
    return {
      mobile: false
    }
  },

  created () {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      this.mobile = true
    }
  }
}
</script>

<style>
#contact {
  font-size: 18px;
  text-align: left;
}

#contact a {
  color: #00a7af;
}

#contact a:visited {
  color: #00a7af;
}

#contact a:hover {
  color: #005358;
}

#contact.mobile {
  font-size: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue